import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';
import Splide from '@splidejs/splide';
import Matter from 'matter-js';

import AOS from 'aos';
import Alpine from 'alpinejs'

const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

// const swup = new Swup({
//   plugins: [new SwupBodyClassPlugin(), new SwupScriptsPlugin()]
// }); 


// Events
// swup.on('contentReplaced', init);

// Start Apline after swup so it works correctly
window.Alpine = Alpine
Alpine.start();


document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  // checkCookie();
  init();
});

// Functions 
function l(m) { 
  console.log(m); 
}

function init() {
  l('👍');
  // cookieNotice();

}

function aosInit() {
  AOS.init({
    duration: 450,
    once: false,
  });
}






let pause = true;
let hover = false;
let urls = [
    '1.jpg',
    '2.jpg',
    '3.jpg',
    '4.jpg',
    '5.jpg',
    '6.jpg',
    '7.jpg',
    '8.jpg'
]

let image_container = document.getElementsByClassName('images');
image_container = image_container[0];
let hot_potato = document.getElementById('buy');

hot_potato.addEventListener("mouseover", function( event ) {
    if(!hover) {
        pause = false;
        document.body.classList.add('image-on');
    }
    hover = true;
}, false);
hot_potato.addEventListener("mouseleave", function( event ) {
    hover = false;
    pause = true;
    document.body.classList.remove('image-on');

}, false);


// let interval = window.setInterval(animate, 300);
// function animate() {
//     if (!pause) {
//         image_container.style.backgroundImage = 'url(img/' + urls[Math.floor(Math.random() * urls.length)] + ')'; 
//     }
// }

setTimeout(function() {
    document.body.classList.add('page-on');
}, 1000);




// var canvas = document.getElementById('world');

// // module aliases
// var Engine = Matter.Engine,
// Render = Matter.Render,
// Runner = Matter.Runner,
// Composites = Matter.Composites,
// Common = Matter.Common,
// MouseConstraint = Matter.MouseConstraint,
// Mouse = Matter.Mouse,
// Composite = Matter.Composite,
// Bodies = Matter.Bodies;



    
    
// // create an engine
// var engine = Engine.create(),
//         world = engine.world;



// // create a renderer
// var render = Render.create({
//     element: document.body,
//     engine: engine
// });

// var render = Render.create({
//   canvas: canvas,
//   engine: engine,
//   options: {
//     width: window.innerWidth,
//     height: window.innerHeight,
//     wireframes: false

//   }

  
// });





// // create two boxes and a ground
// var H = Bodies.rectangle(2000, 20, window.innerWidth / 8, window.innerWidth / 6);
// var O = Bodies.rectangle(2000, 50, window.innerWidth / 8, 80);
// var T = Bodies.rectangle(2000, 200, 80, 80);

// var P = Bodies.rectangle(window.innerWidth / 8, 20, 276, 348, {
//     render: {
//         sprite: {
//             texture: '/texture/P.png'
//         }
//     }
// });

// var O2 = Bodies.rectangle((window.innerWidth / 8) * 2, 200, window.innerWidth / 9, window.innerWidth / 8, {
//   render: {
//     sprite: {
//         texture: '/texture/P.png'
//     }
//   }
// });



// var T2 = Bodies.rectangle((window.innerWidth / 8) * 3, 200, window.innerWidth / 10, window.innerWidth / 6);
// var A = Bodies.rectangle((window.innerWidth / 8) * 4, 200, window.innerWidth / 9, window.innerWidth / 8);
// var T3 = Bodies.rectangle(2000, 50, 80, 80);
// var O3 = Bodies.rectangle(2000, 200, 80, 80);





// var ground = Bodies.rectangle(0, window.innerHeight,  window.innerWidth * 2, 60, { isStatic: true });

// // add all of the bodies to the world
// Composite.add(world, [H, O, T, P, O2, T2, A, T3, O3, ground]);

// // var stack = Composites.stack(20, 20, 10, 4, 0, 0, function(x, y) {

// //   return Bodies.rectangle(window.innerWidth / 8, 20, window.innerWidth / 8, window.innerWidth / 6,{
// //       render: {
// //         strokeStyle: '#ffffff',
// //         sprite: {
// //             texture: './textures/P.png'
// //         }
// //     }
// //   });
  
// // });

// // Composite.add(world, stack);


//     // add mouse control
//     var mouse = Mouse.create(render.canvas),
//         mouseConstraint = MouseConstraint.create(engine, {
//             mouse: mouse,
//             constraint: {
//                 stiffness: 0.2,
//                 render: {
//                     visible: false
//                 }
//             }
//         });

//     Composite.add(world, mouseConstraint);

//     // keep the mouse in sync with rendering
//     render.mouse = mouse;



// // run the renderer
// Render.run(render);

// // create runner
// var runner = Runner.create();

// // run the engine
// Runner.run(runner, engine);